import React from 'react';
import styled from 'styled-components';

import PrimaryButton from 'components/shared/buttons/PrimaryButton';

import clock from 'images/clock.svg';
import dollarBills from 'images/dollar-bills.svg';
import dollarCoin from 'images/dollar-coin.svg';
import tools from 'images/tools.svg';

interface BaseLandingPageProps {
  headerText: string;
  subHeaderText: string;
  callToActionText: string;
  callToActionLink: string;
}

const BaseLandingPageContainer = styled.div`
  position: relative;

  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  button {
    font-size: 20px;
    padding: 12px 25px;
  }

  @media only screen and (min-width: 768px) {
    button {
      font-size: 30px;
      padding: 16px 40px;
    }
  }
`;

const BaseLandingPageVector = styled.img`
  width: 150px;
  height: 150px;

  @media only screen and (min-width: 768px) {
    width: 200px;
    height: 200px;
  }
`;

const ClockVectorContainer = styled.div`
  position: absolute;
  top: 40px;
  left: 20px;

  animation: wobble 2s infinite;

  @media only screen and (min-width: 768px) {
    top: 40px;
    left: 40px;
  }
`;

const DollarBillsVectorContainer = styled.div`
  position: absolute;
  top: 40px;
  right: 20px;

  animation: wobble-reverse 2s infinite;

  @media only screen and (min-width: 768px) {
    top: 40px;
    right: 40px;
  }
`;

const DollarCoinVectorContainer = styled.div`
  position: absolute;
  bottom: 40px;
  right: 20px;

  animation: wobble 2s infinite;

  @media only screen and (min-width: 768px) {
    bottom: 40px;
    right: 40px;
  }
`;

const ToolsVectorContainer = styled.div`
  position: absolute;
  bottom: 40px;
  left: 20px;

  animation: wobble-reverse 2s infinite;

  @media only screen and (min-width: 768px) {
    bottom: 40px;
    left: 40px;
  }
`;

const BaseLandingPageMainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 20px;
  margin-top: 40px;
`;

const BaseLandingPageMainHeader = styled.div`
  font-size: 35px;
  font-family: 'CircularStd-Bold';

  text-align: center;

  span {
    font-family: 'Comfortaa-Bold';
    color: #1d4ed8;
  }

  @media only screen and (min-width: 768px) {
    font-size: 60px;
  }
`;

const BaseLandingPageSubHeader = styled.div`
  font-size: 20px;
  font-family: 'CircularStd-Medium';
  color: rgba(0, 0, 0, 0.6);

  text-align: center;

  width: 80%;

  @media only screen and (min-width: 768px) {
    font-size: 30px;
  }
`;

const BaseLandingPage: React.FC<BaseLandingPageProps> = ({
  headerText,
  subHeaderText,
  callToActionText,
  callToActionLink,
}) => {
  return (
    <BaseLandingPageContainer>
      <ClockVectorContainer>
        <BaseLandingPageVector src={clock} />
      </ClockVectorContainer>
      <DollarBillsVectorContainer>
        <BaseLandingPageVector src={dollarBills} />
      </DollarBillsVectorContainer>
      <DollarCoinVectorContainer>
        <BaseLandingPageVector src={dollarCoin} />
      </DollarCoinVectorContainer>
      <ToolsVectorContainer>
        <BaseLandingPageVector src={tools} />
      </ToolsVectorContainer>

      <BaseLandingPageMainContent>
        <BaseLandingPageMainHeader>
          {headerText} with <span>Sansan Tech</span>
        </BaseLandingPageMainHeader>
        <BaseLandingPageSubHeader>{subHeaderText}</BaseLandingPageSubHeader>
        <a href={callToActionLink}>
          <PrimaryButton
            buttonText={callToActionText}
            loading={false}
            disabled={false}
          />
        </a>
      </BaseLandingPageMainContent>
    </BaseLandingPageContainer>
  );
};

export default BaseLandingPage;
